<template lang="pug">
div
    modal(v-show="isShowModal_",:titulo="'NUEVA ' + nameModulo.toUpperCase()" bindClass="col-md-4 col-sm-12" , @close="isShowModal_=false")
        div(slot='body')  
            .form-group
                .form-row
                    .col-md-12.col-sm-12
                        label Usuario
                        select.form-control.form-control-sm(v-model="parameter.IdUser") 
                            option(v-for="(item,index) in tableUsers", :value="item.IdUser") {{item.NameUser}}
                .form-row
                    .col-md-12.col-sm-12
                        label Sucursal
                        select.form-control.form-control-sm(v-model="parameter.IdBranchOffice") 
                            option(v-for="(item,index) in tableBranchOffices", :value="item.IdBranchOffice") {{item.OfficenName}}
                .form-row 
                    .col-md-12.col-sm-12
                        label Tipo de Acceso
                        select.form-control.form-control-sm(v-model="parameter.TypeAccess")
                            option(value=1) Solo Web
                            option(value=2) Solo Telefono
                            option(value=3) Ambos 
        div(slot='footer')
            button.btn.btn-primary(@click="sendInfo()") Guardar
</template>
<script>
import modal from "../../../complementos/modal.vue"
import toolValidate from '../../../tools/validate.js'
export default {
    props:{ 
        nameModulo:String,
        IsShowModal:Boolean,
        parameter:Object,
        apiWeb:Object
    },  
    components:{
        modal
    },
    computed:{
        isShowModal_ :{
                        get(){return this.IsShowModal },
                        set(val){this.$emit("update:IsShowModal",val)}
        } 
    },
    data(){
        return{
            _idEnterprise:null,
            tableBranchOffices:[],
            tableUsers:[]
        }
    },
    mounted(){
        this._idEnterprise=this.parameter.IdEnterprise
        this.List_BranchOffices()
        this.List_Users()
    },
    updated(){
        if(this._idEnterprise!=this.parameter.IdEnterprise){
            this._idEnterprise=this.parameter.IdEnterprise
            this.List_BranchOffices()
            this.List_Users()
        }
    },
    methods:{
        List_BranchOffices(){
            this.apiWeb.post("BranchOffices/BranchOffices_View",{ IdEnterprise:this.parameter.IdEnterprise,OfficenName:'',Active:'1'})
                    .then(result=>{
                                if(result.status==0)
                                    this.tableBranchOffices=JSON.parse(result.value) 
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        }, 
        List_Users(){
            this.apiWeb.post("Users/Users_View",{ IdEnterprise:this.parameter.IdEnterprise,NameUser:'',Email:'',Active:'1'})
                    .then(result=>{
                                if(result.status==0)
                                    this.tableUsers=JSON.parse(result.value) 
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },  
        sendInfo(){
            if(this.validate()){
                this.$emit("update:parameter",this.parameter)
                this.$emit("sendInfo",this.parameter)
            }       
        },
        validate(){ 
            console.log(this.parameter.IdUser)
            if(this.parameter.IdEnterprise=='0' || this.parameter.IdEnterprise=='' || this.parameter.IdEnterprise==null ){
                this.$msgbox.show("No Hay Empresa Selecionada o Cargada","Alerta")
                return false
            } 
            else if(this.parameter.IdUser=='' || this.parameter.IdUser==null ){
                this.$msgbox.show("Ingrese Usuario","Alerta")
                return false
            }
            else if(this.parameter.IdBranchOffice=='' || this.parameter.IdBranchOffice==null ){
                this.$msgbox.show("Ingrese Sucursal","Alerta")
                return false
            }
            else if(this.parameter.TypeAccess=='' || this.parameter.TypeAccess==null ){
                this.$msgbox.show("Selecione Tipo de Acceso","Alerta")
                return false
            }
            else{
                return true
            }
        }
    }

    
}
</script>